import { render } from "./Parents.vue?vue&type=template&id=2acfb006"
const script = {}

import exportComponent from "/home/harris/Projects/cspd.com.cy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__